import React, { useRef, useState } from "react";
import { useEffect } from "react";
import { allChecklist, get_all_active_checklist } from "../api/Users";

import { useTranslation } from "react-i18next";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { toast } from "react-toastify";
import BorderColorOutlinedIcon from "@material-ui/icons/BorderColorOutlined";
import { useLocation, useNavigate } from "react-router-dom";

import { 
  Card, 
  CardContent, 
  CardActions, 
  Typography, 
  Button, 
  Tooltip, 
  IconButton,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
} from '@mui/material';
import TopLoader from "../components/Loader/TopLoader";


export default function FillChecklist({role, userData}) {
  const { t } = useTranslation();
  const formRef = useRef(null);
  const [photo, setPhoto] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [filteredData, setFilteredData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [rows, setRows] = useState([]);


  const handleImageClick = (imageData) => {
    var w = window.open('about:blank');
    setTimeout(() => {
      w.document.body.appendChild(w.document.createElement('iframe')).src = "data:image/png;base64," + imageData;
      w.document.body.style.margin = 0;
      w.document.getElementsByTagName("iframe")[0].style.width = '100%';
      w.document.getElementsByTagName("iframe")[0].style.height = '100%';
      w.document.getElementsByTagName("iframe")[0].style.border = 0;
    }, 0);
  };
  
  let navigate = useNavigate();
  const view1 = (rowId) => {
    navigate(`/fill-checklist/${rowId}`);
  };

  const handlePhotoChange = (event) => {
    const file = event.target.files[0];
    if (!file) {
      toast.error("No student photo selected!.");
      return;
    }
    const allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i; // Allowed file types

    if (!allowedExtensions.test(file.name)) {
      toast.error("Invalid file type. Only JPG and PNG files are allowed.");
      event.target.value = "";
      return;
    }
    setPhoto(file);
  };

  const generatePDF = async () => {
    if (!formRef.current) return;

    const form = formRef.current;
    const pdf = new jsPDF();

    await renderPage(form, pdf);

    pdf.save("fill_checklist.pdf");
  };

  const renderPage = async (form, pdf) => {
    const canvas = await html2canvas(form, {
      scale: 3,
    });

    const imgData = canvas.toDataURL("image/png");

    const margins = {
      top: 20,
      bottom: 20,
      left: 20,
      right: 20,
    };

    const availableWidth =
      pdf.internal.pageSize.getWidth() - margins.left - margins.right;
    const availableHeight =
      pdf.internal.pageSize.getHeight() - margins.top - margins.bottom;

    const contentAspectRatio = canvas.width / canvas.height;

    let contentWidth = availableWidth;
    let contentHeight = availableWidth / contentAspectRatio;

    if (contentHeight > availableHeight) {
      contentHeight = availableHeight;
      contentWidth = availableHeight * contentAspectRatio;
    }

    const x = (pdf.internal.pageSize.getWidth() - contentWidth) / 1.5;
    const y = (pdf.internal.pageSize.getHeight() - contentHeight) / 1.5;

    pdf.addImage(
      imgData,
      "PNG",
      margins.left,
      margins.top,
      contentWidth,
      contentHeight
    );
  };
  useEffect(() => {
    setIsLoading(true);
    console.log(role);
    setIsLoading(true);
    let data = {
      gm_id: userData.data.gm_id,
    };
    get_all_active_checklist(data)
      .then((res) => {
        if (res.status === "success") {
          setFilteredData(res.data.checklist);
        } else {
          setRows([]);
        }
      })
      .catch((error) => {
        toast.error(t("Something went wrong"));
      })
    setIsLoading(false);
  }, []);

  return (
    <>
    <TopLoader loading={isLoading ? "50" : "100"} />
      <div className="mb-4 col-12 mt-3 mx-3">
          <h5 className="">{t("All Checklist")}</h5>
        <div className="my-4">
          {!isLoading && filteredData && filteredData.length > 0 ? (
            <div style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
              {filteredData
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => (
                  <Card key={index} style={{ width: 300, marginLeft:"2rem" }}>
                    <CardContent>
                    {row.image && (
                        <img
                          src={`data:image/png;base64,${row.image}`}
                          alt="Checklist"
                          style={{
                            width: "100%",
                            maxHeight: "200px",
                            objectFit: "cover",
                            marginTop: "10px",
                          }}
                          onClick={() => handleImageClick(row.image)}
                        />
                      )}
                      <Typography variant="h6" component="div" align="center">
                        {row.additionalData.name}
                      </Typography>
                      <Typography variant="body1" align="center">
                        
                        {row.additionalData.category}
                      </Typography>
                      {/* <Typography variant="body1" align="center">
                        Total Questions: {row.additionalData.total_questions}
                      </Typography>
                      
                      <Typography
                        variant="body2"
                        align="center"
                        style={{ marginTop: "10px" }}
                      >
                        Posted At: {row.additionalData.posted_at}
                      </Typography> */}
                    </CardContent>
                    <CardActions style={{ justifyContent: "center" }}>
                      <Tooltip title="Fill Checklist">
                        <IconButton
                          onClick={() => view1(row.additionalData.id)}
                        >
                          <BorderColorOutlinedIcon />
                        </IconButton>
                      </Tooltip>
                    </CardActions>
                  </Card>
                ))}
            </div>
          ) : (
            <Typography
              variant="h4"
              align="center"
              style={{ marginTop: "20px" }}
            >
              <i>{t("No data available")}</i>
            </Typography>
          )}
        </div>
      </div>
    </>
  );
}
